import { Flex } from "antd";
import React, { useContext } from "react";

import { GlobalContext } from "@tools/globalContext";

const HeaderExtensions : React.FC = () => {
    const { headerConfig } = useContext(GlobalContext);

    return <Flex gap={5}>
        <></>
    </Flex>
}

export default HeaderExtensions;